import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";

/**
 * Iter-586 — server-side share streak (replaces any local post
 * counting so streaks survive phone changes and match app + web):
 *   GET /api/classifieds/engagement/my/share-streak (auth) →
 *   { posts_total, posts_verified, milestones, next_milestone,
 *     posts_to_next, milestone_hit }
 */
export function useShareStreak(enabled = true) {
  const hasToken = typeof window !== "undefined" && !!localStorage.getItem("allsale_token");
  return useQuery({
    queryKey: ["share-streak"],
    enabled: enabled && hasToken,
    retry: 0,
    staleTime: 15_000,
    queryFn: async () =>
      (
        await sharedApi.get("/classifieds/engagement/my/share-streak", {
          headers: { "X-App-Platform": "nz_classified" },
          params: { platform: "nz_classified" },
        })
      ).data,
  });
}
